import PageLoader from '../../UI/loader/PageLoader';
import ProtectionPoliciesContentNew from './protection-policies/ProtectionPoliciesContentNew';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import NetWorthAccordion from './net-worth/NetWorthAccordion';
import useFinancialItems from 'src/financial/financial-data/hooks/useFinancialItems';

export const FinancialContent = () => {
  const { clientId, client } = useCurrentClient();

  const {
    isLoading: loadingFinancialItems,
    refetch: refetchFinancialItems,
    isFetching,
    ...financialItems
  } = useFinancialItems(clientId);

  const refetch = async () => {
    await Promise.all([refetchFinancialItems()]);
  };

  if (loadingFinancialItems || !client) {
    return <PageLoader absolute={false} />;
  }

  return (
    <>
      <NetWorthAccordion onSubmit={refetch} financialItems={financialItems} isFetching={isFetching} />
      <ProtectionPoliciesContentNew
        policies={financialItems.protections}
        clientFirstName={client.firstName}
      />
    </>
  );
};
